<script setup lang="ts">
</script>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: 'CardBackground',

    props: {
        tilt: {
            type: Object,
            required: true,
        },

        tiltAngle: {
            type: Number,
            required: true,
        },

        bgUrl: {
            type: String,
            required: true,
        },
    },

    computed: {
        computedTilt(): string
        {
            const x = 50 + 15 * (this.tilt.x / this.tiltAngle)
            const y = 50 - 25 * (this.tilt.y / this.tiltAngle)
            return `${x}% ${y}%`
        },
    },
})
</script>

<template>
    <div class="content absolute-fill">
        <div class="background absolute-fill"/>
        <div class="bgShadow absolute-fill"/>
        <div class="bottomShadow absolute-fill"/>
    </div>
</template>

<style scoped lang="scss">
.content {
    position: absolute;
    width: 100%;
    height: 100%;

    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;

    justify-content: flex-start;
    align-items: flex-end;

    .background {
        z-index: 0;
        border-radius: 20px;
        overflow: hidden;
        background-image: v-bind('`url("/img/page/landing/registration/cardBg/${bgUrl}")`');
        background-position: v-bind('computedTilt');
        //filter: blur(1px);
        background-size: 1000px 1000px;
    }

    .bgShadow {
        z-index: 10;
        box-shadow: inset 0 -5px 15px 10px black;
    }

    .bottomShadow {
        z-index: 10;
        background: linear-gradient(0deg, rgba(0,0,0,0.8) 20%, rgba(0,0,0,0) 65%);
    }
}
</style>
